import { createProductParameter } from "@bevco/Store/Handlers/Utilities/useProductParameter";
import throwErrorIfTesting from "@insite/client-framework/Common/ThrowErrorIfTesting";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";

interface Parameter {
    productId: string;
    qtyOrdered?: number;
    unitOfMeasure?: string;
    numberOfSpools?: number;
}

type HandlerType = Handler<Parameter>;

const PRODUCT_COMPARE_CAROUSEL_ID = "product-compare-carousel-id";

export const DispatchBeginLoadProduct: HandlerType = props => {
    throwErrorIfTesting();

    props.dispatch({
        type: "Custom/LoadingPrice/BeginLoadingPrice",
        productId: props.parameter.productId,
    } as any);
};

export const LoadRealTimePricing: HandlerType = props => {
    const productParameter = createProductParameter(props.parameter);
    if (!productParameter) {
        return;
    }

    props.dispatch(
        loadRealTimePricing({
            productPriceParameters: [productParameter],
            onSuccess: realTimePricing => {
                const pricing = realTimePricing.realTimePricingResults!.find(
                    o => o.productId === productParameter.productId,
                );
                if (pricing) {
                    props.dispatch({
                        type: "Components/ProductInfoLists/CompleteLoadRealTimePricing",
                        id: PRODUCT_COMPARE_CAROUSEL_ID,
                        realTimePricing,
                    });
                } else {
                    props.dispatch({
                        type: "Components/ProductInfoLists/FailedLoadRealTimePricing",
                        id: PRODUCT_COMPARE_CAROUSEL_ID,
                    });
                }

                props.dispatch({
                    type: "Custom/LoadingPrice/CompleteLoadingPrice",
                    productId: props.parameter.productId,
                } as any);
            },
            onError: () => {
                props.dispatch({
                    type: "Components/ProductInfoLists/FailedLoadRealTimePricing",
                    id: PRODUCT_COMPARE_CAROUSEL_ID,
                });
            },
            onComplete(realTimePricingProps) {
                if (realTimePricingProps.apiResult) {
                    this.onSuccess?.(realTimePricingProps.apiResult);
                } else if (realTimePricingProps.error) {
                    this.onError?.(realTimePricingProps.error);
                }
            },
        }),
    );
};

export const chain = [DispatchBeginLoadProduct, LoadRealTimePricing];

const updateProductInfoProductCompare = createHandlerChainRunner(chain, "UpdateProductInfoProductCompare");

export default updateProductInfoProductCompare;
